import { computed } from 'vue';

export interface AppearanceProps {
  showBackground?: boolean;
  backgroundImage?: string;
  size?: 'small' | 'medium' | 'large' | 'auto';
  fullHeight?: boolean;
  primaryColor?: string;
  secondaryColor?: string;
  fontPrimary?: string;
  fontSecondary?: string;
}

/** Classes and style bindings derived from the visual props of the widget. */
export const useWidgetAppearance = (props: AppearanceProps) => {
  const wrapperClasses = computed(() => ({
    'widget-wrapper-full-height': props.fullHeight,
    'widget-wrapper-auto': !props.fullHeight,
    [`widget-size-${props.size}`]: props.size !== 'auto',
  }));

  const containerClasses = computed(() => ({
    [`widget-container-${props.size}`]: props.size !== 'auto',
  }));

  const backgroundStyle = computed(() => ({
    backgroundImage: props.backgroundImage ? `url('${props.backgroundImage}')` : undefined,
  }));

  const widgetStyle = computed(() => ({
    '--widget-primary-color': props.primaryColor,
    '--widget-secondary-color': props.secondaryColor,
    '--widget-font-primary': props.fontPrimary,
    '--widget-font-secondary': props.fontSecondary,
  }));

  return { wrapperClasses, containerClasses, backgroundStyle, widgetStyle };
};
